export const environment = {
  production: true,
  baseUrl: 'https://stg-cloud-api.lorex.com/',
  gtmId: 'GTM-NHT6ZLBX'
};
